const KO_DEVELOPMENT = [{
  label: 'Story',
  value: 1,
  key: 1,
  icon: 'StoryFilled',
  color: '#1565c0',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Task',
  value: 2,
  key: 2,
  icon: 'TaskFilled',
  color: '#2e7d32',
  background: 'rgba(165,214,167,0.16)'
}, {
  label: 'Subtask',
  value: 3,
  key: 3,
  icon: 'SubtaskFilled',
  color: '#00897b',
  background: 'rgba(128,222,234,0.16)'
}, {
  label: 'Bug',
  value: 4,
  key: 4,
  icon: 'BugFilled',
  color: '#c62828',
  background: 'rgba(255,171,145,0.16)'
}, {
  label: 'Improvement',
  value: 5,
  key: 5,
  icon: 'ImprovementsFilled',
  color: '#f9a825',
  background: 'rgba(255,241,118,0.16)'
}, {
  label: 'Epic',
  value: 6,
  key: 6,
  icon: 'ImprovementsFilled',
  color: '#f9a825',
  background: 'rgba(255,241,118,0.16)'
}, {
  label: 'Feature request',
  value: 7,
  key: 7,
  icon: 'FeatureRequestFilled',
  color: '#283593',
  background: 'rgba(197,202,233,0.16)'
}, {
  label: 'Change request',
  value: 8,
  key: 8,
  icon: 'ChangerequestFilled',
  color: '#37474f',
  background: 'rgba(176,190,197,0.16)'
}, {
  label: 'Support',
  value: 9,
  key: 9,
  icon: 'SupportFilled',
  color: '#00695c',
  background: 'rgba(178,223,219,0.16)'
}];

export { KO_DEVELOPMENT };
